import { render } from "./SecureUploadLanding.vue?vue&type=template&id=40904774&scoped=true"
import script from "./SecureUploadLanding.vue?vue&type=script&lang=js"
export * from "./SecureUploadLanding.vue?vue&type=script&lang=js"

import "./SecureUploadLanding.vue?vue&type=style&index=0&id=40904774&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40904774"]])

export default __exports__